import axios from 'axios';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import LoaderComponent from 'components/LoaderComponent';
import MediDataDownloadSearchView from 'components/medidata-download/MediDataDownloadSearchView';
import MediDataDownloadTableView from 'components/medidata-download/MediDataDownloadTableView';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { RouterProps } from 'react-router';
import { Segment } from 'semantic-ui-react';
import { getBillXmlResponse } from 'services/mediDataServices';
import { getAllTariffs } from 'services/tariffServices';
import styled from 'styled-components';
import { TariffDto, XmlResponseRequestDto } from 'ts-types/api.types';
import { IndexSignature } from 'utils/praxTypes';
import { withRouterWorkaround } from 'utils/workaroundUtils';

const ContentDiv = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledHealthCardPayment = styled(Segment.Group)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-top: 0 !important;
  background: white;

  & .ui.grid > .row {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  & .ui.grid > .row:first-child {
    padding-bottom: 1rem !important;
  }

  & .ui.grid {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;


interface Props extends MessageSourceProps, RouterProps, PatientConsumerRenderProps {
}

interface State extends IndexSignature {
  requiredDataLoaded: boolean,
  mandateId: number,
  tariffId: number,
  billId?: number,
  patientId?: number,
  xmlResponses: Array<XmlResponseRequestDto>,
  responseLoading: boolean,
  responsesUpdating: boolean,
  tariffs: Array<TariffDto>,
  errorMessages: Array<string>
}

class MediDataDownloadView extends Component<Props, State> {

  cancelTokenSource = axios.CancelToken.source();

  constructor(props: Props) {
    super(props);

    this.state = {
      requiredDataLoaded: false,
      xmlResponses: [],
      mandateId: -1,
      tariffId: -1,
      billId: -1,
      responseLoading: false,
      responsesUpdating: false,
      tariffs: [],
      cancelTokenSource: this.cancelTokenSource,
      errorMessages: []
    }

    this.loadRequiredData(props);
  }

  loadRequiredData(props: Props) {
    getAllTariffs(this.cancelTokenSource)
        .then(tariffs => {
          this.setState({
            tariffs
          });
        })
        .finally(() => {
          this.setState({
            requiredDataLoaded: true
          });
        });
  }

  goToHome = () => {
    const {history} = this.props;

    history.push("/");
  };

  onSearchResponses = (
      mandateId: number,
      tariffId: number,
      billId: number | undefined,
      patientId: number | undefined) => {

    this.setState({
      mandateId: tariffId,
      tariffId: tariffId,
      billId: billId,
      patientId: patientId
    });

    this.onResponseLoadingChange(true);

    getBillXmlResponse(mandateId, tariffId, billId, patientId, this.cancelTokenSource)
        .then(response => {
          let xmlResponses = response;
          this.setState({
            xmlResponses
          });
        })
        .finally(() => {
          this.onResponseLoadingChange(false);
        });
  }

  refreshResponses = () => {
    const {
      mandateId,
      tariffId,
      billId,
      patientId
    } = this.state;

    this.onSearchResponses(mandateId, tariffId, billId, patientId);
  }

  onResponseLoadingChange = (isLoading: boolean) => {
    this.setState({responseLoading: isLoading})
  };

  onResponsesUpdating = (responsesUpdating: boolean) => {
    this.setState({
      responsesUpdating
    });
  }

  onSetErrorMessages = (errorMessages: Array<string>) => {
    this.setState({
      errorMessages
    })
  }

  render(): React.ReactNode {

    const {
      tariffs,
      xmlResponses,
      responseLoading,
      responsesUpdating,
      requiredDataLoaded,
      errorMessages
    } = this.state;

    const {getMessage} = this.props;

    if (!requiredDataLoaded) {
      return <></>;
    }

    return (
        <ContentDiv>
          <FullScreenPageHeader headerMessage={getMessage("header.navigation.mediDataDownload")}
                                buttonMessage={getMessage("back")}
                                onConfirm={() => this.goToHome()}/>

          <StyledHealthCardPayment>
            {
                responsesUpdating
                && <LoaderComponent message={getMessage("mediData.updateResponses.loader")}/>
            }
            <MediDataDownloadSearchView
                onSearchResponses={this.onSearchResponses}
                onResponseLoadingChange={this.onResponseLoadingChange}
                onResponsesUpdating={this.onResponsesUpdating}
                onSetErrorMessages={this.onSetErrorMessages}
                errorMessages={errorMessages}
                responsesUpdating={responsesUpdating}
                tariffs={tariffs}
            />
            <MediDataDownloadTableView
                xmlResponses={xmlResponses}
                responsesLoading={responseLoading}
                refreshResponses={this.refreshResponses}
            />
          </StyledHealthCardPayment>
        </ContentDiv>
    );
  }
}

export default withRouterWorkaround(withPatientContext(withMessages(MediDataDownloadView)));
